// eslint-disable-next-line
export const ACTIONS_NAMESPACE = '@@GA';
